<template>
  <a-modal
    :confirmLoading='confirmLoading'
    :title='title'
    :visible='visible'
    :width='800'
    @cancel='handleCancel'
    @ok='handleOk'>
    <a-spin :spinning='confirmLoading'>
      <div v-if="!formListVisible">
        <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
          <a-form-model-item  label="选择周期">
            <a-select v-model="followPeriodId" placeholder="请选择访视周期" style='min-width: 200px'  allow-clear>
                <a-select-option :value="item.id" v-for="(item,key) in followList" :key="key">
                  {{item.groupName?item.groupName + (item.groupStatus=='2'?'(终止)':'') +" "+ item.name:item.name}}
                </a-select-option>
              </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item prop="sortNum" label="序号">
            <a-input-number v-model="model.sortNum" placeholder="请输入序号" :min="0" :precision="0" style="width: 100%"/>
          </a-form-model-item> -->

        </a-form-model>
        <div class='main-box' style='border: 1px solid #EFEFEF'>
          <div class="row">
            <a-button size="small" icon="plus" type="primary" @click="addFormList">添加</a-button>
          </div>
          <div class='be_choose_crf'>
            <a-table :columns='columns'
                     :dataSource='model.formList'
                     :loading='confirmLoading'
                     :pagination='false'
                     rowKey='id'
                     size='small'>
            <span slot="action" slot-scope="text, record,index">
              <a @click="removeByIndex(index)">删除</a>
            </span>
              <!-- <span slot="group" slot-scope="text, record">
                <a-select v-model=' record.groupId' style="width: 100%" allowClear>
                  <a-select-option v-for="group in formGroupList" :value="group.id" :key="group.id">{{group.name}}</a-select-option>
                </a-select>
              </span> -->
            <!-- <span slot="sortNum" slot-scope="text, record">
              <a-input-number v-model="record.sortNum" :min="0" :precision="0" style="width: 100%" placeholder="请输入排序" />
            </span> -->
            </a-table>
          </div>
        </div>
      </div>
      <div v-else>
        <form-list @addFormListHandle="addFormListHandle" :existIdList="existIdList" @handleOk="handleOk"></form-list>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
  import baseRules from '@/constants/baseRules'
  import { getAction,postAction,deleteAction } from '@/api/manage'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  import FormList from '@views/project/setting/visit/FormList'
  export default {
    name: 'PatientPeriodFormAdd',
    components: { FormList },
    props:{
      patient:{
        type:Object,
        default:function(){
          return {}
        }
      },
    },
    data() {
      return {
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        title: '添加表单',
        visible: false,
        readonly: false,
        model: {
          formList:[],          
        },
        confirmLoading: false,
        isEdit: false,
        rules:{
          name:[baseRules.requiredChange],
          sortNum:[baseRules.required],
        },
        formListVisible:false,
        formGroupList:[],
        followList: [],
        followPeriodId: undefined,
      }
    },
    computed: {
      columns() {
        const operate = {
          title: '操作',
          align: 'center',
          width: 160,
          scopedSlots: { customRender: 'action' },
      }
        const columns = [
          // {
          //   title: '排序',
          //   align: 'sortNum',
          //   scopedSlots: { customRender: 'sortNum' },
          //   width: 200
          // },
          {
            title: '表单',
            dataIndex: 'formName',
            align: 'center',
            ellipsis: true
          },
          {
            title: '表单项数',
            align:"center",
            dataIndex: 'itemCount',
            width: 100
          },
          // {
          //   title: '分组类型',
          //   // dataIndex: '分组类型',
          //   align: 'center',
          //   width: 200,
          //   scopedSlots: { customRender: 'group' },
          // }
        ]
        if (!this.readonly) {
          return [...columns, operate]
        }
        return columns
      },
      existIdList(){
        return this.model.formList.map(item=>item.formId)
      }
    },
    created() {      
      this.loadForm()
    },
    methods: {
      loadForm(){
        // getAction('/project/projectVisitFormGroup/list',{projectId:this.projectId}).then(res=>{
        //   if(res.success){
        //     this.formGroupList = res.result
        //   }
        // })
      },
      add() {
        //初始化默认值
        this.edit({
          sortNum: 1,
          projectId:this.projectId
        })
      },
      edit(record) {
        this.handleOpen(record,true)
      },
      view(record) {
        this.handleOpen(record,false)
      },
      handleOpen(record,edit){
        this.loadFollowData()
        this.isEdit = edit
        record.formList = record.formList || []
        this.model = Object.assign({}, record)
        this.visible = true
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        if(this.formListVisible){
          this.formListVisible = false
        }
        else{
          this.submit()
        }
      },
      submit(){
        this.$refs.ruleForm.validate(valid  => {
          if(valid){
            if(!this.followPeriodId){
              return this.$message.warning('请选择访视周期')
            }            
            if(!this.model.formList || this.model.formList.length===0){
              return this.$message.warning('请选择表单')
            }
            // let error = false
            // this.model.formList.forEach(item=>{
            //   if(!item.sortNum){
            //     error= true
            //   }
            // })
            // if(error){
            //   return this.$message.warning('请填写排序字段')
            // }
            this.confirmLoading = true
            postAction('/patient/patientPeriodItem/addForm',{formIdList:this.model.formList.map(item=>item.formId),followPeriodId:this.followPeriodId}).then(res=>{
              if(res.success){
                this.$message.success(res.message)
                this.close()
              }else{
                this.$message.warning(res.message);
              }
            }).finally(()=>{
              this.confirmLoading= false
            })
          }

        })

        // this.close()
      },
      handleCancel() {
        this.close()
      },
      addFormListHandle(record){
        const that = this
        if(this.model.formList.filter(item=>item.formId===record.id).length>0){
          return this.$message.warning('重复添加')
        }
        // record.sortNum = record.sortNum || 1
        this.model.formList.push({
          // sortNum:this.model.formList?this.model.formList.length+1:1,
          formId:record.id,
          formName:record.name,
          itemCount:record.itemCount,
        })
        // this.$confirm({
        //   title: '提示',
        //   content: '添加成功，要继续添加吗 ?',
        //   onOk() {
        //   },
        //   onCancel() {
        //     that.formListVisible = false
        //   },
        // });
      },
      removeByIndex(index){
        this.model.formList.splice(index,1)        
        // for(let j=0;j<this.model.formList.length;j++){
        //   if(j>=index){
        //     this.model.formList[j].sortNum = this.model.formList[j].sortNum - 1
        //   }
        // }
      },
      addFormList(){
        this.formListVisible = true
      },
      loadFollowData(){
        getAction('/patient/patientPeriodItem/list',{patientId:this.patient.id}).then(res=>{
          if(res.success){
            this.followList = res.result   
            this.followPeriodId = undefined            
          }
        })
      },
      
    }
  }
</script>

<style lang='less' scoped>
  .visit_name_row {
    margin-bottom: 8px;
  }
  .main-box {
    padding: 12px;
  }

  /deep/ .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td  .ant-select-selection {
    border: 0!important;
  }
</style>
